import styles from "./OnboardingStyles.module.css"
import RecommendVideo from '../../assets/animations/recommend.mp4';
import { useTranslation } from "react-i18next";

const RecommendLoader = () => {
    const { t } = useTranslation(); // Translation
    
    return (
        <>
            <div className={styles.LoaderWrap}>
                <video
                    className={styles.BackgroundVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    <source src={RecommendVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className={styles.LoaderBg}></div>
            <div className={styles.LoaderContent}>
                <div className={styles.LoaderTitle}>
                    <p>{t("onboarding.loader.title")}</p>
                    </div>
                    <div className={styles.LoaderBar}>
                        <div className={styles.Loader}>
                            <div className={styles.LoaderProgress}></div>
                        </div>
                        <div className={styles.LoaderText}>
                            <p>{t("onboarding.loader.screen_tip")}</p>
                        </div>
                    </div>
            </div>
        </div>
        </>
    )
}

export default RecommendLoader